var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "VLayout",
    [
      _c(
        "VTextField",
        {
          ref: _vm.ref,
          class: [
            "ns-v-input",
            "flex-column",
            _vm.type,
            { "with-icon": _vm.icon }
          ],
          attrs: {
            id: _vm.id,
            "data-testid": _vm.dataTestid,
            rules: _vm.rules.length > 0 ? _vm.rules : _vm.requiredRules,
            type: _vm.type,
            disabled: _vm.disabled,
            placeholder: _vm.placeholder,
            required: _vm.required,
            "validate-on-blur": _vm.validateOnBlur,
            name: _vm.name,
            "aria-describedby": _vm.id
          },
          on: {
            blur: function($event) {
              return _vm.onBlur()
            }
          },
          model: {
            value: _vm.inputValue,
            callback: function($$v) {
              _vm.inputValue = $$v
            },
            expression: "inputValue"
          }
        },
        [
          _c("template", { slot: "label" }, [
            _c("span", { staticClass: "field-label" }, [
              _vm._v(_vm._s(_vm.label))
            ])
          ]),
          _vm._v(" "),
          _c(
            "template",
            { slot: "prepend-inner" },
            [
              _vm.icon
                ? _c("NsIcon", {
                    staticClass: "inner-icon",
                    attrs: { "icon-name": _vm.icon }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }